import { Injectable } from '@angular/core';
import { ApiNameList } from '../../../../../environments/api-name-list';
import { HttpClientService } from '../../../../common/services/http-client-service';

@Injectable()
export class HistoryService {
  public baseUrl = '';
  constructor(public httpClientService: HttpClientService) {
    this.baseUrl = ApiNameList.restApi.baseUrl;
  }

  getUserEnrollments(): any {
    const requestObject = {};
    return this.httpClientService.post(
      this.baseUrl + ApiNameList.restApi.getUserEnrollments,
      requestObject
    );
  }
  downloadReceipt(enrollmentId: string): any {
    const requestObject = {
      enrollmentId,
    };
    return this.httpClientService.post(
      this.baseUrl + ApiNameList.restApi.downloadReceipt,
      requestObject
    );
  }
  getEnrollmentHistory(enrollmentId: string): any {
    const requestObject = {
      enrollmentId,
    };
    return this.httpClientService.post(
      this.baseUrl + ApiNameList.restApi.enrollmentHistory,
      requestObject
    );
  }
  getEnrollmentHistoryForMicrosite(requestObject: any): any {
    return this.httpClientService.post(
      this.baseUrl + ApiNameList.restApi.micrositeEnrollmentHistory,
      requestObject
    );
  }
  getDependents(enrollmentId: string): any {
	 const requestObject = {
      enrollmentId
    };
    return this.httpClientService.post(
      this.baseUrl + ApiNameList.restApi.getDependents,
      requestObject
    );
  }
  getPlanStatus(request: any): any {
    return this.httpClientService.post(
      this.baseUrl + ApiNameList.restApi.planStatus,
      request
    );
  }
  updateDependent(
    enrollmentId: string,
    dependentId: string,
    depDetails: object
  ): any {
    const requestObject = {
      enrollmentId,
      dependentId,
      depDetails,
    };
    return this.httpClientService.post(
      this.baseUrl + ApiNameList.restApi.updateDependent,
      requestObject
    );
  }
}
